// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hLSsLb5JUzULYI_Eck8Q{padding-top:40px}.AsbvQCbosr8wYHwL6fyh{padding-top:31px;padding-left:4px}.nD0EszKV1R43mXNEebZt{color:var(--content-brand-primary);cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `hLSsLb5JUzULYI_Eck8Q`,
	"textBottomWrap": `AsbvQCbosr8wYHwL6fyh`,
	"link": `nD0EszKV1R43mXNEebZt`
};
export default ___CSS_LOADER_EXPORT___;
